module.exports = __webpack_public_path__ + "img/platform-6.bda82268.png";